import * as Actions from '../../../Modules/CmsActions'
import type { CmsAdmin, IPagination } from '../../../Types'

interface IState {
  pagination: IPagination | null
  list: CmsAdmin[]
  loading: boolean
  edit: CmsAdmin | null
}

const initialState: IState = {
  pagination: null,
  list: [],
  loading: true,
  edit: null,
}

const UIUserReducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case Actions.REQUEST_SEARCH_USER:
    case Actions.REQUEST_FIND_USER:
      return { ...state, loading: true }

    case Actions.FINISH_SEARCH_USER:
      return {
        ...state,
        loading: false,
        list: payload.users,
        pagination: payload.pagination,
      }

    case Actions.FINISH_FIND_USER:
      return { ...state, loading: false, edit: payload.cmsAdmin }

    default:
      return state
  }
}

export default UIUserReducer
